import {
    type EndEventApplicationResponseType,
    type EndEventApplicationRequestType
} from "./type";
import {
    request
} from "../request";

const EndEventApplication = async (params: EndEventApplicationRequestType): Promise<EndEventApplicationResponseType> => {
    return await request<EndEventApplicationResponseType>("/events/endEventApplication", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default EndEventApplication;
